// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__pCViw","scrollY":"Wrapper_scrollY__8njIH"};